import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'FelicaStore',
  namespaced: true,
  stateFactory: true
})
export default class FelicaStore extends BaseStore {
  _reading: boolean = false

  get reading(): boolean {
    return this._reading
  }

  @Mutation
  public startRead(): void {
    this._reading = true
  }

  @Mutation
  public endRead(): void {
    this._reading = false
  }
}
